<template>
  <div class="map-chart2" id="map-chart2">
    <div class="homepage-title">监控总览</div>
    <el-button class="back-btn" v-if="backMapNumber!=1" @click="backClick()">返回<i></i></el-button>
    <div :style="{height:'88%',width:'100%'}" id="main2" class="echarts"></div>
    <div class="ranking-message">
      <div class="ranking-title">场站收入排行</div>
      <vue-seamless-scroll :data="listData.station" class="seamless-warp" :class-option="classOption">
        <ul>
          <li v-for="(item,index) in listData.station" :key="index">
            <span class="left-border" :class="{'border-two': index == 1,'border-three': index == 2,'border-four': index == 3,'border-five': index == 4,'crimson': index == 5}">{{index+1}}</span>
            <span class="income-title">{{item.station_name}}</span>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <div class="ranking-message-right">
      <div class="ranking-title">城市收入排行</div>
      <vue-seamless-scroll :data="listData.city" class="seamless-warp" :class-option="classOption">
        <ul>
          <li v-for="(item,index) in listData.city" :key="index">
            <span class="left-border" :class="{'border-two': index == 1,'border-three': index == 2,'border-four': index == 3,'border-five': index == 4,'crimson': index == 5}">{{index+1}}</span>
            <span class="income-title">{{item.city}}</span>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import $echarts from "echarts";
import cityMap from "@/js/citymap.js";
import $axios from "axios";
const provinces = {
  //23个省
  台湾: "taiwan",
  河北: "hebei",
  山西: "shanxi",
  辽宁: "liaoning",
  吉林: "jilin",
  黑龙江: "heilongjiang",
  江苏: "jiangsu",
  浙江: "zhejiang",
  安徽: "anhui",
  福建: "fujian",
  江西: "jiangxi",
  山东: "shandong",
  河南: "henan",
  湖北: "hubei",
  湖南: "hunan",
  广东: "guangdong",
  海南: "hainan",
  四川: "sichuan",
  贵州: "guizhou",
  云南: "yunnan",
  陕西: "shanxi1",
  甘肃: "gansu",
  青海: "qinghai",
  //5个自治区
  新疆: "xinjiang",
  广西: "guangxi",
  内蒙古: "neimenggu",
  宁夏: "ningxia",
  西藏: "xizang",
  //4个直辖市
  北京: "beijing",
  天津: "tianjin",
  上海: "shanghai",
  重庆: "chongqing",
  //2个特别行政区
  香港: "xianggang",
  澳门: "aomen"
};
export default {
  data() {
    return {
      geoData: [
        // { name: "南山", value: 1 },
        // {name: "A",value: "3"},
        // {name: "福田",value: "3"},
        // {name: "南山",value: "20"},
        // {name: "宝安",value: "3"},
        // {name: "商城县",value: "3"},
      ],
      geoCoordMap: {
        // 南山: [113.972534, 22.630444],
        // A: ["114.054540", "22.522910"],
        // 南山: ["113.972534", "22.630444"],
        // 商城县: ["115.404900", "31.802210"],
        // 宝安:  ["113.941790", "22.561370"],
        // 福田: ["114.086950", "22.546230"],
      },
      geoArr: [],
      listData: {},
      list: [],
      width: "",
      geoTitle:"",
      mapData01:[],
      mapData02:[],
      mapData03:[],
      backMapName:"",
      backMapNumber:1,

      
      special: ["北京", "天津", "上海", "重庆", "香港", "澳门"],
      mapdata: [],
      originalValue: [], // 保存最初的全国地图的 series 的 data
      option: {
        title: {
          text: "",
          subtext: "",//上方下钻标题
          left: "center",
          subtextStyle: {
            color: "#ffffff",
            fontSize: 10,
            fontWeight: "normal",
            fontFamily: "Microsoft YaHei"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}"
        },
        toolbox: {
          show: false,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          },
          iconStyle: {
            normal: {
              color: "#fff"
            }
          }
        },
        animationDuration: 1000,
        animationEasing: "cubicOut",
        animationDurationUpdate: 1000,
        visualMap: {
          type: "continuous",
          min: 0,
          max: 300,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          // color: ["#01C86D", "#3280d5"],
        },
        dataRange: {//控制有数据区域的颜色
          show: false,
          min: 0,
          max: 5,
          x: '5%',
          y: '80%',
          // min: 0,
          // max: 1000,
          // x: "left",
          // y: "bottom",
          // text: ["High", "Low"],
          // inRange: {},
          // calculable: true,
          color: ["#00c86c", "#317fd4"],
        },
        
      }
    };
  },
  mounted() {
    let o = document.getElementById("map-chart2");
    this.$nextTick(function() {

      if(this.$store.state.getMapStations!=""){
        this.getEchartData();
        this.getListData();
      }

      // this.getEchartData();
      // this.getListData();
    });
  },
  computed:{
    classOption(){
      return {
        step:0.5,//数值越大速度滚动越快
        limitMoveNum: 3,// limitMoveNum指的是修改后的参数，是容器的高度
        singleHeight:90,//一屏播放的高度
        waitTime:3000,//每播放一屏停顿的时间
      }
    }
  },
  components: {
  　　vueSeamlessScroll
  },
  destroyed() {
    window.onresize = null;
  },
  ready() {
    // let echart = echarts.init(document.getElementById("echarts"));
    // echart.on("click",this.myChartClick);
  },
  methods: {
    getEchartData() {
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action: "getMapStations"
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret +=
      //           encodeURIComponent(it) +
      //           "=" +
      //           encodeURIComponent(data[it]) +
      //           "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
        let su =this.$store.state.getMapStations
          if (su.data.code == 1) {
            // this.list = su.data.list;
            // this.chinaConfigure(this.list);
            this.mapData01 = su.data.list.mapData01;
            this.mapData02 = su.data.list.mapData02;
            this.mapData03 = su.data.list.mapData03;
            // for(let i in this.mapData02){
            //   if(this.mapData02[i].zone1.indexOf("市") != -1){
            //     this.mapData02[i].zone1 = this.mapData02[i].zone1;
            //   } else {
            //     this.mapData02[i].zone1 = this.mapData02[i].zone1 + "市";
            //   }
            // }
            this.initChart();
            // console.log(this.mapData01);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        // })
        // .catch(err => {});
    },
    initChart() {
      let chart = $echarts.init(document.getElementById("main2"));
      let _self = this;
      $axios.get("/static/public/map/china.json").then(function(res) {
        let d = [];
        for (var i = 0; i < res.data.features.length; i++) {
          for(let j in _self.mapData01){
            if(_self.mapData01[j].province == res.data.features[i].properties.name){
              d.push({
                name: res.data.features[i].properties.name,
                value: _self.mapData01[j].num,
                selected:true,
                latitude: _self.mapData01[j].latitude,
                longitude: _self.mapData01[j].longitude,
              });
            } else {}
          }
        }
        _self.mapdata = d;
        _self.originalValue = d;
        //注册地图
        $echarts.registerMap("china", res.data);
        //绘制地图
        _self.renderMap("china", d,1);
      });
      //地图点击事件
      chart.on("click", function(params) {
        // console.log( params.name );
        if (params.name in provinces) {
          //如果点击的是34个省、市、自治区，绘制选中地区的二级地图
          $axios
            .get("/static/public/map/province/" + provinces[params.name] + ".json")
            .then(function(res) {
              
              $echarts.registerMap(params.name, res.data);
              var d = [];
              // console.log( params.name );
              if (_self.special.indexOf(params.name) >= 0) {
                // debugger
                for (var i = 0; i < res.data.features.length; i++) {
                  for(let j in _self.mapData03){
                    if(_self.mapData03[j].zone2 == res.data.features[i].properties.name){
                      d.push({
                        name: res.data.features[i].properties.name,
                        value: _self.mapData03[j].num,
                        selected:true,//echarts 绘制地图设置其中某些板块高亮（颜色）
                        latitude: _self.mapData03[j].latitude,
                        longitude: _self.mapData03[j].longitude,
                      });
                    } else {
                    }
                  }
                }
                // console.log(11);
                // console.log(d);
              } else {
                // console.log(22);
                for (var i = 0; i < res.data.features.length; i++) {
                  for(let j in _self.mapData02){
                    if(_self.mapData02[j].zone1 == res.data.features[i].properties.name){
                      d.push({
                        name: res.data.features[i].properties.name,
                        value: _self.mapData02[j].num,
                        selected:true,
                        latitude: _self.mapData02[j].latitude,
                        longitude: _self.mapData02[j].longitude,
                      });
                    } else {
                    }
                  }
                }
              }
              
              _self.renderMap(params.name, d,2);
            }).catch(err => {
              // //注册地图
              // console.log(11);
              // $echarts.registerMap("china", res.data);
              // //绘制地图
              // _self.renderMap("china", d,1);
            });
        } else if (params.seriesName in provinces) {
          //如果是【直辖市/特别行政区】只有二级下钻
          if (_self.special.indexOf(params.seriesName) >= 0) {
            _self.renderMap("china", _self.mapdata,1);
          } else {
            //显示县级地图
            if(cityMap[params.name] == undefined){  //点击第二级向第三级的时候找不到json文件时回到全国地图
              // console.log(11);
              _self.renderMap("china", _self.originalValue,1);
            } else {
              
              $axios
              .get("/static/public/map/city/" + cityMap[params.name] + ".json")
              .then(function(res) {
                
                $echarts.registerMap(params.name, res.data);
                var d = [];
                for (var i = 0; i < res.data.features.length; i++) {
                  for(let j in _self.mapData03){
                    if(_self.mapData03[j].zone2 == res.data.features[i].properties.name){
                      d.push({
                        name: res.data.features[i].properties.name,
                        value: _self.mapData03[j].num,
                        selected:true,//echarts 绘制地图设置其中某些板块高亮（颜色）
                        latitude: _self.mapData03[j].latitude,
                        longitude: _self.mapData03[j].longitude,
                      });
                    } else {
                    }
                  }
                }
                // debugger
                _self.renderMap(params.name, d,3); 
              });
            }
            
          }
        } else {
          _self.renderMap("china", _self.originalValue,1);
        }
      });
    },
    renderMap(map, data,number) {
      // console.log(map);
      // console.log(number);
      // console.log(data);
      if(number == 2){
        this.backMapName = map;
      }
      this.backMapNumber = number;
      // console.log(this.backMapName);
      // console.log(this.backMapNumber);
      let chart = $echarts.init(document.getElementById("main2"));
      // this.option.title.subtext = map;//上方下钻标题
      this.geoData = [];
      this.geoCoordMap = {};
      this.geoTitle = "";
      let zoom = 1.1;
      if(number == 1){
        zoom = 1.1;
        this.geoTitle = "";
      } else if(number == 2){
        if(map == "重庆" || map == "北京" || map == "天津" || map == "上海"){
          zoom = 1.2;
        } else if(map == "内蒙古" || map == "黑龙江" || map == "广东" || map == "辽宁" || map == "福建" || map == "甘肃") {
          zoom = 0.7;
        } else if(map == "河南") {
          zoom = 0.85;
        } else {
          zoom = 1.0;
        }
        this.geoTitle = "";
      } else if(number == 3){
        zoom = 1.0;
        for (var i = 0; i < data.length; i++) {
          this.geoData.push({
            name: data[i].name,
            value: data[i].value,
          });
          this.geoCoordMap[data[i].name] = [
            data[i].longitude,
            data[i].latitude
          ];
        }
        if(data.length != 0){
          this.geoTitle = map;
        } else {
          this.geoTitle = "";
        }
        // console.log(this.geoCoordMap);
      } else if(number == 4){
        zoom = 1.1;
        this.geoTitle = "";
      }
      
      // console.log(this.geoCoordMap);
      this.option.geo =  {
        map: this.geoTitle,
        show: false,
        roam: false,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: "#F0F8FB"
            }
          },
          emphasis: {
            // 对应的鼠标悬浮效果
            show: false,
            textStyle: {
              color: "#F0F8FB"
            }
          }
        },
        itemStyle: {
          normal: {
            show: false,
            areaColor: "#0d202e",//有数据第三级背景色
            borderColor: "rgba(0, 0, 0, 0.2)",
          },
          emphasis: {
            areaColor: "#00c86c"
          }
        }
      };
      
      this.option.series = [
        {
          tooltip: {
            trigger: "item",
            formatter: p => {
              //自定义提示信息
              let dataCon = p.data;
              let txtCon =
                dataCon.name + " " + "场站数" + " : " + dataCon.value[2];
              return txtCon;
            }
          },
          show: false,
          roam: false,
          type: "effectScatter",
          coordinateSystem: "geo",
          showAllSymbol: true,
          symbolSize: 20,
          symbol:
            "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAArlBMVEUAAACqqgD//wC/vwD//wDV1Sv//yvq6hX/6hX/6xTt7RL/7ST27Rr27hr37h737x338Bv48Br48B747R337x337x337x338Bz38Bz47hv48Bv27xv27x347x328B358Bz28Bz58Bz37hv58B337x358R337x337xz47xv27xv47xz37xv37xz58B358B358B348Bv58Bv38Bz48Rz38Bz38B337xv37xv48Bz////Eer9hAAAAOHRSTlMAAwMEBAYGDAwNDg46Ozw+Q0RFR2BhYmRlaGhyc3N0dnd3e3t8fH2Ajo+QocvLzPDy8vf3+Pn8/ZxQyHYAAAABYktHRDnXAJVAAAAAnElEQVQY03WQxxKCUBAExywGzGLAiNqYEPP7/y/zQIFaYh+ntnZ3WpIkyx64C3dgW4rJtzwils1cFJUd3jglSSqO+GRYkNQB8IPwEh59gLZUXQH7mzHGmOse8CpqALu7ibhtAVt9IDAxB6CnKRAm2QlwtQGeSfYA1pr8zI1T99V/7tZS/4t7nM056aFs96tvN/PHS6q/yPOcWez5Bam3MAvM/3lWAAAAAElFTkSuQmCC",
          symbolRotate: 35,
          label: {
            normal: {
              formatter: "",
              // position: "right",
              show: false,
              textStyle: {
                fontSize: 10,
              },
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            normal: {
              fontSize: 10,
              areaColor: "#00C76C"
            }
          },
          data: this.convertData(this.geoData)
        },
        {
          name: map,
          type: "map",
          mapType: map,
          roam: false,
          zoom:zoom,//地图缩放比例
          tooltip: {
            trigger: "item",
            textStyle: {
              align: "left"
            },
            formatter: function(a, b, c) {
              // console.log(a);
              var txtCon = "";
              if (isNaN(a.value)) {
                txtCon = a.name + " " + "场站数" + " : " + 0;
              } else {
                txtCon = a.name + " " + "场站数" + " : " + a.value.toFixed(0);
              }
              return txtCon;
            }
          },
          nameMap: {
            china: "中国"
          },
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#ffffff",//地图文字颜色
                fontSize: 10,//地图文字大小
              }
            },
            emphasis: {
              // 对应的鼠标悬浮效果
              show: true,
              textStyle: {
                color: "#F0F8FB",
              }
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#3280d5",//整个地图背景色
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              label:{show:true},
              areaColor: "#01C86D",//鼠标悬停背景色
            }
          },
          data: data
        }
      ];
      //渲染地图
      chart.setOption(this.option);
    },
    backClick(){
      // console.log(this.backMapNumber);
      let chart = $echarts.init(document.getElementById("main2"));
      let _self = this;
      if(this.backMapNumber == 2){
        $axios.get("/static/public/map/china.json").then(function(res) {
          let d = [];
          for (var i = 0; i < res.data.features.length; i++) {
            for(let j in _self.mapData01){
              if(_self.mapData01[j].province == res.data.features[i].properties.name){
                d.push({
                  name: res.data.features[i].properties.name,
                  value: _self.mapData01[j].num,
                  selected:true,
                  latitude: _self.mapData01[j].latitude,
                  longitude: _self.mapData01[j].longitude,
                });
              } else {}
            }
          }
          _self.mapdata = d;
          _self.originalValue = d;
          //注册地图
          $echarts.registerMap("china", res.data);
          //绘制地图
          _self.renderMap("china", d,1);
        });
      } else if(this.backMapNumber == 3) {
        // console.log(_self.backMapName);
        if (_self.backMapName in provinces) {
          //如果点击的是34个省、市、自治区，绘制选中地区的二级地图
          $axios
            .get("/static/public/map/province/" + provinces[_self.backMapName] + ".json")
            .then(function(res) {
              
              $echarts.registerMap(_self.backMapName, res.data);
              var d = [];
              for (var i = 0; i < res.data.features.length; i++) {
                for(let j in _self.mapData02){
                  if(_self.mapData02[j].zone1 == res.data.features[i].properties.name){
                    d.push({
                      name: res.data.features[i].properties.name,
                      value: _self.mapData02[j].num,
                      selected:true,
                      latitude: _self.mapData02[j].latitude,
                      longitude: _self.mapData02[j].longitude,
                    });
                  } else {
                  }
                }
              }
              _self.renderMap(_self.backMapName, d,2);
            }).catch(err => {
              // //注册地图
              // console.log(11);
              // $echarts.registerMap("china", res.data);
              // //绘制地图
              // _self.renderMap("china", d,1);
            });
        } else {
          _self.renderMap("china", _self.originalValue,1);
        }
      }
    },


    
    
    convertData(data) {
      // console.log(data);
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      // console.log(res);
      return res;
    },
    chinaConfigure(data) {
      var series = JSON.parse(JSON.stringify(data));
      var legendData = [];
      for (let i = 0; i < series.length; i++) {
        legendData.push({ name: series[i].province, value: series[i].num });
      }

      for (var i = 0; i < this.list.length; i++) {
        this.geoData.push({
          name: this.list[i].zone1,
          value: this.list[i].num
        });
        this.geoArr.push({
          key: this.list[i].zone1,
          value: [this.list[i].longitude, this.list[i].latitude]
        });
        this.geoCoordMap[this.list[i].zone1] = [
          this.list[i].longitude,
          this.list[i].latitude
        ];
      }

      let echart = echarts.init(document.getElementById("echarts"));

      var option = {
        tooltip: {
          // trigger:"axis",
          trigger: "item",
          textStyle: {
            align: "left"
          },
          formatter: function(a, b, c) {
            // console.log(a);
            var txtCon = "";
            if (isNaN(a.value)) {
              txtCon = a.name + " " + a.seriesName + " : " + 0;
            } else {
              txtCon = a.name + " " + a.seriesName + " : " + a.value;
            }
            return txtCon;
            // seriesName
          }
        },
        visualMap: {
          show: true,
          min: 0,
          max: 1500,
          left: "left",
          top: "bottom",
          text: ["High", "Low"],
          seriesIndex: [1],
          inRange: {
            color: ["#01C86D", "#3280d5"]
          },
          calculable: true
        },
        dataRange: {
          show: false,
          min: 0,
          max: 1000,
          x: "left",
          y: "bottom",
          text: ["High", "Low"],
          inRange: {
            color: ["#01C86D", "#3280d5"]
          },
          calculable: true
        },
        geo: {
          map: "china",
          zoom: 1,
          scaleLimit: { min: 0, max: 3 }, // 缩放级别
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#F0F8FB"
              }
            },
            emphasis: {
              // 对应的鼠标悬浮效果
              show: false,
              textStyle: {
                color: "#F0F8FB"
              }
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#3280d5",
              borderColor: "rgba(0, 0, 0, 0.2)"
            },
            emphasis: {
              borderWidth: 0,
              borderColor: "#0066ba",
              areaColor: "#00C76C",
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        },
        series: [
          {
            tooltip: {
              trigger: "item",
              formatter: p => {
                //自定义提示信息
                let dataCon = p.data;
                let txtCon =
                  dataCon.name + " " + "场站数" + " : " + dataCon.value[2];
                return txtCon;
              }
            },
            type: "scatter",
            roam: true,
            coordinateSystem: "geo",
            showAllSymbol: true,
            symbolSize: 20,
            symbol:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAArlBMVEUAAACqqgD//wC/vwD//wDV1Sv//yvq6hX/6hX/6xTt7RL/7ST27Rr27hr37h737x338Bv48Br48B747R337x337x337x338Bz38Bz47hv48Bv27xv27x347x328B358Bz28Bz58Bz37hv58B337x358R337x337xz47xv27xv47xz37xv37xz58B358B358B348Bv58Bv38Bz48Rz38Bz38B337xv37xv48Bz////Eer9hAAAAOHRSTlMAAwMEBAYGDAwNDg46Ozw+Q0RFR2BhYmRlaGhyc3N0dnd3e3t8fH2Ajo+QocvLzPDy8vf3+Pn8/ZxQyHYAAAABYktHRDnXAJVAAAAAnElEQVQY03WQxxKCUBAExywGzGLAiNqYEPP7/y/zQIFaYh+ntnZ3WpIkyx64C3dgW4rJtzwils1cFJUd3jglSSqO+GRYkNQB8IPwEh59gLZUXQH7mzHGmOse8CpqALu7ibhtAVt9IDAxB6CnKRAm2QlwtQGeSfYA1pr8zI1T99V/7tZS/4t7nM056aFs96tvN/PHS6q/yPOcWez5Bam3MAvM/3lWAAAAAElFTkSuQmCC",
            symbolRotate: 35,
            label: {
              normal: {
                formatter: "",
                position: "right",
                show: false
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                areaColor: "#00C76C"
              }
            },
            data: this.convertData(this.geoData)
          },
          {
            name: "场站数",
            type: "map",
            geoIndex: 0,
            data: legendData
          }
        ]
      };
      echart.setOption(option);
      const that = this;
      // window.addEventListener("resize", function() {
      //   return (() => {
      //     echart.resize();
      //   })();
      // });
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function() {
          window.onresize = function() {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
    myChartClick(param) {
      // debugger
      // console.log(param.name);
    },
    getListData() {
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action: "getStationIncomeSort"
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret +=
      //           encodeURIComponent(it) +
      //           "=" +
      //           encodeURIComponent(data[it]) +
      //           "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
        let su=this.$store.state.getStationIncomeSort
          if (su.data.code == 1) {
            this.listData = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        // })
        // .catch(err => {});
    }
  }
};
</script>

<style scoped lang="scss">
.map-chart2 {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .homepage-title {
    color: #fffffd;
    // position: absolute;
    margin-left: 20px;
    margin-bottom: 20px;
    left: 22px;
  }
  .back-btn {
    background-color: #1196db;
    color: #FFFFFF;
    border:none;
    width: 70px;
    height: 30px;
    text-align: left;
    padding: 0;
    padding-left: 10px;
    line-height: 30px;
    font-size: 12px;
    position: absolute;
    top:50px;
    left: 4%;
    cursor: pointer;
    z-index: 10;
    i {
      display: inline-block;
      width: 16px;
      height: 14px;
      background: url(../../../assets/img/icon_back.png) no-repeat;
      position: absolute;
      top:6px;
      right:10px;
    }
  }
  .echarts {
    // margin-top: -20px;
    z-index: 0;
  }
  .ranking-message {
    width: 24%;
    height: 112px;
    position: absolute;
    left: 25px;
    bottom:10px;
    z-index: 999;
    .ranking-title {
      font-size: 14px;
      font-family: "microsoft yahei";
      color:#FFFFFF;
      text-align: left;
      margin-bottom: 8px;
    }
    .seamless-warp {
      width: 100%;
      height: 80%;
      overflow: hidden;
    }
    ul {
      list-style: none;
      li {
        width: 100%;
        height: 30px;
        font-size: 12px;
        position: relative;
        .left-border {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 7px;
          background-color: #F73939;
          color: #fffffd;
          text-align: center;
          line-height: 16px;
        }
        .left-border.border-two {
          background-color: #FF7812;
        }
        .left-border.border-three {
          background-color: #33B76B;
        }
        .left-border.border-four {
          background-color: #4B8EFF;
        }
        .left-border.border-five {
          background-color: #702FFF;
        }
        .income-title {
          display:inline-block;
          width: 80%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          left: 10%;
          line-height: 30px;
        }
        .income-data {
          display:inline-block;
          width: 24%;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          right: 30%;
          line-height: 30px;
          span {
            font-size: 12px;
          }
        }
        .income-percentage {
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          right: 12%;
          line-height: 30px;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
  .ranking-message-right {
    width: 13%;
    height: 112px;
    position: absolute;
    right: 25px;
    bottom:10px;
    z-index: 999;
    .ranking-title {
      font-size: 14px;
      font-family: "microsoft yahei";
      color:#FFFFFF;
      text-align: right;
      margin-bottom: 8px;
    }
    .seamless-warp {
      width: 100%;
      height: 80%;
      overflow: hidden;
    }
    ul {
      list-style: none;
      li {
        width: 100%;
        height: 30px;
        position: relative;
        .left-border {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 7px;
          background-color: #F73939;
          color: #fffffd;
          text-align: center;
          line-height: 16px;
          font-size: 12px;  
        }
        .left-border.border-two {
          background-color: #FF7812;
        }
        .left-border.border-three {
          background-color: #33B76B;
        }
        .left-border.border-four {
          background-color: #4B8EFF;
        }
        .left-border.border-five {
          background-color: #702FFF;
        }
        .income-title {
          display:inline-block;
          width: 70%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          left: 24%;
          line-height: 30px;
        }
        .income-data {
          display:inline-block;
          width: 44%;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          right: 0%;
          line-height: 30px;
          span {
            font-size: 12px;
          }
        }
        .income-percentage {
          color: #5FC8FF;
          font: 12px 'microsoft yahei';
          position: absolute;
          right: 12%;
          line-height: 30px;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}
@media screen and (min-width:1701px) and (max-width:1880px){
  .map-chart2 {
    .ranking-message-right {
      width: 12%;
    }
  }
}
@media screen and (min-width:1550px) and (max-width:1700px){
  .map-chart2 {
    .echarts {
      margin-top: 0px;
      z-index: 0;
    }
    .ranking-message {
      left: 20px;
      bottom:12px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 16%;
          }
          .income-data {
            right:6%;
            width: 40%;
          }
        }
      }
    }
    .ranking-message-right {
      // width: 14%;
      right:20px;
      bottom:12px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 28%;
          }
          .income-data {
            right:1%;
          }
        }
      }
    }
  }
}
@media screen and (min-width:1450px) and (max-width:1550px){
  .map-chart2 {
    .homepage-title {
      font-size: 12px;
      top:7px;
      left: 7px;
    }
    .echarts {
      margin-top: 0px;
      z-index: 0;
    }
    .ranking-message {
      left: 20px;
      bottom:12px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 16%;
          }
          .income-data {
            right:6%;
            width: 40%;
          }
        }
      }
    }
    .ranking-message-right {
      width: 14%;
      right:20px;
      bottom:12px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 28%;
          }
          .income-data {
            right:1%;
          }
        }
      }
    }
  }
}

@media screen and (min-width:1322px) and (max-width:1449px){
  .map-chart2 {
    .homepage-title {
      font-size: 12px;
      top:7px;
      left: 7px;
    }
    .echarts {
      margin-top: 0px;
      z-index: 0;
    }
    .ranking-message {
      left: 18px;
      bottom:10px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 16%;
          }
          .income-data {
            right:6%;
            width: 40%;
          }
        }
      }
    }
    .ranking-message-right {
      width: 14%;
      right:18px;
      bottom:10px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 28%;
          }
          .income-data {
            right:1%;
          }
        }
      }
    }
  }
}
@media screen and (max-width:1321px){
.map-chart2 {
    .homepage-title {
      font-size: 12px;
      top:7px;
      left: 7px;
    }
    .echarts {
      margin-top: 0px;
      z-index: 0;
    }
    .ranking-message {
      left: 18px;
      bottom:10px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 16%;
          }
          .income-data {
            right:6%;
            width: 40%;
          }
        }
      }
    }
    .ranking-message-right {
      width: 14%;
      right:18px;
      bottom:10px;
      height: 86px;
      .ranking-title {
        font-size: 12px;
        margin-bottom: 0px;
      }
      ul {
        li {
          height: 24px;
          .left-border {
            top:5px;
          }
          .income-title {
            line-height: 24px;
            left: 28%;
          }
          .income-data {
            right:1%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/displayScreen/mapChart.vue